export default __webpack_public_path__ + "static/media/84.bd2dc18c.jpg";